<template>
    <div class=" homecontainer container-fluid no-gutters w-container">
        <div class="row row-grid align-items-center">
            <div class="text-center">
                <!--top Image -->
                <figure class="w-100">
                    <img alt="Image placeholder" src="../assets/img/exchange/topbg.jpg" class="img-fluid">
                </figure>
            </div>
        </div>
        <!-- <router-view></router-view> -->

        <div class="row justify-content-center">
            <div class="col-lg-12 mb-3 justify-content-center text-center">
                <h2 class="mt-4">两岸交流</h2>
            </div>
            <!--two Card -->
            <div class="content-container row mt-5 mb-5  justify-content-center">
                <div class="col-md-12 no-gutters ">
                    <div class="row pb-3 justify-content-center no-gutters">
                        <div class="col-5 col-md-5 col-lg-4 containbg">
                            <img src="../assets/img/exchange/img-1.jpg" class="img-fluid img-center"
                                alt="Illustration" />
                        </div>
                        <div class="col-6 col-md-6 pl-3 pt-4 pb-5 containbg">
                            <h5 class="h4 lh-130 mb-0">中华民族文化发展协会</h5>
                            <p class="text-muted mb-0">
                                Chinese National Cultural Development Association<br><br>
                                从前期策划到执行拍摄，从影片剪辑到三维，从创意到回面。从文
                                字到配乐策划团队、拍摄团队、后期团队，新视文化控所有核心战
                                斗力这一切，只为了让您的影片具有性价比，只为了让您的影片品
                                质更可控只为了让您享受影视创作服务。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 no-gutters">
                    <div class="row pb-5 justify-content-center no-gutters">
                        <div class="col-6 col-md-6 pl-4 pr-4 pt-4 pb-5 containbg">
                            <h5 class="h4 mb-0">海峡两岸街舞交流 </h5>
                            <p class="text-muted">
                                Cross Strait street dance exchange<br><br>
                                这次街舞交流赛不仅是一场艺术的竞技，更是一座文化交流的桥梁。
                                我们希望通过这样的活动，促进两岸青年的相互理解和友谊，
                                共同推动中华文化的传承与发展。艺术是不分地域和语言的，
                                它是连接两岸同胞心灵的最强纽带。今天我们在这里举办的街舞大赛，
                                将成为两岸文化交流的又一重要里程碑。
                            </p>
                        </div>
                        <div class="col-5 col-md-5 col-lg-4 no-gutters containbg">
                            <img src="../assets/img/exchange/img-2.jpg" class="img-fluid img-center"
                                alt="Illustration" />

                        </div>
                    </div>
                </div>
            
                <ul class="col-md-10 list-group " style="padding-left: 15px;" >
                    <li class="list-group-item" v-for="(item, index) in newsList" :key="index" @click="clickBtn(item)">
                        <div class="row ">
                            <div class='ml-3'>                                
                                <img :src="item.img"  class="img-fluid img-center"
                                    style="height: 100px;" alt="Illustration" />
                            </div>
                            <div class='col-8 col-md-8 pl-3'>
                                <h5 class="h6 mb-1">{{ item.title }} </h5>
                                <h5 class="small mb-1">{{ item.content }}</h5>
                                <small class="mb-1">{{ item.date }} </small>
                            </div>
                        </div>
                    </li>
                    
                </ul>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Exchange',
    data() {
        return {
            newsList:[
                {
                id:'202302',
                title:'共同传承和弘扬中华优秀音乐文化，京台音乐文化交流联盟在宋庄成立',
                img:require("../assets/img/exchange/img-6.webp"),
                url:'https://mp.weixin.qq.com/s/DB8Y1vqjnI1Lj6dvOofILA',
                content:'为弘扬中华民族传统文化，促进两岸文化交流与合作，推动两岸设计产业发展，增进两岸民众情感。近日，在宋庄镇大洲玉文化创意园举行了...',
                date:'2024-05-28',
            },
            {
                id:'202303',
                title:'第二届520“爱的表白”海峡两岸「中国首饰」设计大赛颁奖典礼',
                img:require("../assets/img/exchange/img-3.jpg"),
                url:'https://mp.weixin.qq.com/s/vOcHT4dDPvGS6cIQOLmlXg',
                content:'9月28日，备受瞩目的第二届“520”海峡两岸中国首饰设计大赛颁奖典礼在北京大洲玉文化创意园盛大举行。此次活动邀请了北京市台办、北京市台联、通州区台办和宋庄镇政府等各级领导参加。',
                date:'2024-09-30',
            }
        ],
        }
    },
    methods:{
        clickBtn(item){
            console.log(item);
            // this.$router.push(item.url)
            window.open(item.url, '_blank');
            // this.$router.push({
            //     name:'newsDetail',
            //     query:{
            //         path:item.url
            //     }
            // })
        }
    },
}
</script>

<style lang="less" scoped>
.containbg {
    background-color: #eff2ed;
}
</style>